import { retrieveProviderProfileReducer } from "@user-management-context/read/application/use-cases/provider/provider-profile-retrieval/retrieve-provider-reducer";
import { updateProviderProfileReducer } from "@user-management-context/write/application/use-cases/provider/provider-profile-update/update-provider-profile-reducer";
import { retrieveProviderStudiosReducer } from "@academy-context/read/application/use-cases/provider/studios-retrieval/retrieve-provider-studios-reducer";
import { retrieveProviderStudioReducer } from "@academy-context/read/application/use-cases/provider/studio-retrieval/retrieve-provider-studio-reducer";
import { createProviderStudioReducer } from "@academy-context/write/application/use-cases/provider/studio-create/create-provider-studio-reducer";
import { updateProviderStudioReducer } from "@academy-context/write/application/use-cases/provider/studio-update/update-provider-studio-reducer";

export const providerReducers = {
  profileRetrieval: retrieveProviderProfileReducer,
  profileUpdate: updateProviderProfileReducer,
  studiosRetrieval: retrieveProviderStudiosReducer,
  studioRetrieval: retrieveProviderStudioReducer,
  studioCreate: createProviderStudioReducer,
  studioUpdate: updateProviderStudioReducer,
};
